import { Navigate, Outlet, useLocation } from 'react-router';
import { useAppSelector } from '../store/store';
import { Box, CircularProgress } from '@mui/material';

export function FullScreenLoader() {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <CircularProgress />
    </Box>
  );
}

/** Bloquea rutas privadas mientras hidrata. Redirige a /login si no hay sesión. */
export function PrivateRoute() {
  const { user, hydrated, memberships } = useAppSelector((s) => s.auth);
  const location = useLocation();
  if (!hydrated) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  if (!user.isSuperAdmin) {
    const path = location.pathname;
    if (!memberships?.length) {
      if (path !== '/no-tenant') return <Navigate to="/no-tenant" replace />;
    }
  }
  return <Outlet />;
}

/** Para /login: si ya hay sesión, redirige al destino correcto. */
export function PublicRoute() {
  const { user, hydrated, memberships } = useAppSelector((s) => s.auth);
  if (!hydrated) return <FullScreenLoader />;
  if (user) {
    if (user.isSuperAdmin) return <Navigate to="/home" replace />;
    if (!memberships?.length) return <Navigate to="/no-tenant" replace />;
    return <Navigate to="/home" replace />;
  }
  return <Outlet />;
}

/** Restringe rutas a roles específicos (además de SuperAdmin que pasa siempre). */
export function RoleRoute({ roles, allowSuper = true, fallback = '/home' }: { roles: string[]; allowSuper?: boolean; fallback?: string }) {
  const user = useAppSelector((s) => s.auth.user);
  if (!user) return <Navigate to="/login" replace />;
  if (allowSuper && user.isSuperAdmin) return <Outlet />;
  if (user.roleName && roles.includes(user.roleName)) return <Outlet />;
  return <Navigate to={fallback} replace />;
}

export function SuperAdminRoute() {
  const user = useAppSelector((s) => s.auth.user);
  if (!user) return <Navigate to="/login" replace />;
  if (!user.isSuperAdmin) return <Navigate to="/home" replace />;
  return <Outlet />;
}
